// extracted by mini-css-extract-plugin
export default {"wrapper":"qg647vmpU3Dig8sskOCg","boxWrapper":"kVB0KAa60RAz7eNgB60P"};